import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FightCardProduct, Product } from './FightCardProduct';
const FIGHTERS = [{
  id: 'f1',
  name: 'THE IRON',
  initials: 'TI',
  color: 'rgba(80,80,80,0.6)'
}, {
  id: 'f2',
  name: 'BLOOD WOLF',
  initials: 'BW',
  color: 'rgba(120,20,20,0.6)'
}, {
  id: 'f3',
  name: 'CAGE KING',
  initials: 'CK',
  color: 'rgba(100,80,10,0.6)'
}, {
  id: 'f4',
  name: 'DARK HORSE',
  initials: 'DH',
  color: 'rgba(20,40,100,0.6)'
}];
const FIGHTER_PRODUCTS: Record<string, Product[]> = {
  f1: [{
    id: 'fp1',
    name: 'IRON SIGNATURE TEE',
    price: 45,
    category: 'SHIRTS',
    fighter: 'THE IRON',
    image: 'https://images.unsplash.com/photo-1583743814966-8936f5b7be1a?q=80&w=1000&auto=format&fit=crop'
  }, {
    id: 'fp2',
    name: 'IRON LEGACY HOODIE',
    price: 95,
    category: 'HOODIES',
    fighter: 'THE IRON',
    image: 'https://images.unsplash.com/photo-1556821840-3a63f95609a7?q=80&w=1000&auto=format&fit=crop'
  }],
  f2: [{
    id: 'fp3',
    name: 'WOLF PACK CAP',
    price: 35,
    category: 'CAPS',
    fighter: 'BLOOD WOLF',
    image: 'https://images.unsplash.com/photo-1588850561407-ed78c282e89b?q=80&w=1000&auto=format&fit=crop'
  }, {
    id: 'fp4',
    name: 'PREDATOR SHORTS',
    price: 75,
    category: 'FIGHTWEAR',
    fighter: 'BLOOD WOLF',
    image: 'https://images.unsplash.com/photo-1591195853828-11db59a44f6b?q=80&w=1000&auto=format&fit=crop'
  }],
  f3: [{
    id: 'fp5',
    name: 'KINGDOM RASHGUARD',
    price: 65,
    category: 'FIGHTWEAR',
    fighter: 'CAGE KING',
    image: 'https://images.unsplash.com/photo-1517438476312-10d79c077509?q=80&w=1000&auto=format&fit=crop'
  }],
  f4: [{
    id: 'fp6',
    name: 'DARK HORSE TEE',
    price: 45,
    category: 'SHIRTS',
    fighter: 'DARK HORSE',
    image: 'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?q=80&w=1000&auto=format&fit=crop'
  }]
};
interface FighterCollectionProps {
  onAddToCart: (product: Product) => void;
}
export function FighterCollection({
  onAddToCart
}: FighterCollectionProps) {
  const [selectedFighter, setSelectedFighter] = useState(FIGHTERS[0]);
  return <section id="fighters" className="py-24 relative" style={{
    background: '#0d0d0d'
  }} data-id="element-86">
      {/* Subtle ambient glow */}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse at 50% 50%, rgba(153,27,27,0.04) 0%, transparent 60%)'
    }} data-id="element-87" />

      <div className="max-w-7xl mx-auto px-4 md:px-6 relative z-10" data-id="element-88">
        <div className="mb-12" data-id="element-89">
          <h2 className="text-5xl md:text-7xl font-bebas mb-8" style={{
          color: '#e0e0e0'
        }} data-id="element-90">
            FIGHTER{' '}
            <span style={{
            color: '#333'
          }} data-id="element-91">
              COLLECTIONS
            </span>
          </h2>

          {/* Glass Fighter Tabs */}
          <div className="flex gap-4 overflow-x-auto pb-4" data-id="element-92">
            {FIGHTERS.map(fighter => <button key={fighter.id} onClick={() => setSelectedFighter(fighter)} className="flex items-center gap-4 min-w-[190px] p-2 pr-5 rounded-full transition-all duration-400" style={selectedFighter.id === fighter.id ? {
            background: 'rgba(255,255,255,0.05)',
            backdropFilter: 'blur(12px)',
            border: '1px solid rgba(245,230,20,0.2)',
            boxShadow: '0 0 20px rgba(245,230,20,0.06)'
          } : {
            background: 'rgba(255,255,255,0.02)',
            backdropFilter: 'blur(8px)',
            border: '1px solid rgba(255,255,255,0.06)'
          }} data-id="element-93">
                <div className="w-11 h-11 rounded-full flex items-center justify-center font-bebas text-lg flex-shrink-0" style={{
              background: selectedFighter.id === fighter.id ? `${fighter.color}` : 'rgba(255,255,255,0.04)',
              border: selectedFighter.id === fighter.id ? '1px solid rgba(245,230,20,0.25)' : '1px solid rgba(255,255,255,0.07)',
              color: selectedFighter.id === fighter.id ? '#e0e0e0' : '#555',
              boxShadow: selectedFighter.id === fighter.id ? '0 0 12px rgba(245,230,20,0.1)' : 'none'
            }} data-id="element-94">
                  {fighter.initials}
                </div>
                <span className="font-bebas text-lg tracking-wide" style={{
              color: selectedFighter.id === fighter.id ? '#e0e0e0' : '#555'
            }} data-id="element-95">
                  {fighter.name}
                </span>
              </button>)}
          </div>
        </div>

        {/* Products Grid */}
        <div className="min-h-[400px]" data-id="element-96">
          <AnimatePresence mode="wait" data-id="element-97">
            <motion.div key={selectedFighter.id} initial={{
            opacity: 0,
            y: 16
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -16
          }} transition={{
            duration: 0.3
          }} className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6" data-id="element-98">
              {FIGHTER_PRODUCTS[selectedFighter.id]?.map(product => <FightCardProduct key={product.id} product={product} onAddToCart={onAddToCart} data-id="element-99" />)}
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </section>;
}